import { defineComponent as _defineComponent } from 'vue';
import BootstrapVue from "bootstrap-vue";
import { storeToRefs } from "pinia";
import Vue, { computed, ref } from "vue";
import { publishedHistoriesFetcher } from "@/api/histories";
import { invocationsFetcher } from "@/api/invocations";
import { jobsFetcher } from "@/api/jobs";
import { workflowsFetcher } from "@/api/workflows";
import { useHistoryStore } from "@/stores/historyStore";
import MarkdownSelector from "./MarkdownSelector.vue";
import MarkdownVisualization from "./MarkdownVisualization.vue";
import DataDialog from "@/components/DataDialog/DataDialog.vue";
import BasicSelectionDialog from "@/components/SelectionDialog/BasicSelectionDialog.vue";
import DatasetCollectionDialog from "@/components/SelectionDialog/DatasetCollectionDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownDialog',
    props: {
        argumentName: { default: undefined },
        argumentType: { default: undefined },
        argumentPayload: { default: undefined },
        labels: null,
        useLabels: { type: Boolean }
    },
    emits: ["onCancel", "onInsert"],
    setup(__props, { emit }) {
        const props = __props;
        Vue.use(BootstrapVue);
        const selectorConfig = {
            job_id: {
                labelTitle: "Step",
            },
            invocation_id: {
                labelTitle: "Step",
            },
            history_dataset_id: {
                labelTitle: "Output",
            },
            history_dataset_collection_id: {
                labelTitle: "Output",
            },
        };
        const selectedShow = ref(false);
        const visualizationShow = ref(false);
        const workflowShow = ref(false);
        const historyShow = ref(false);
        const jobShow = ref(false);
        const invocationShow = ref(false);
        const dataShow = ref(false);
        const dataCollectionShow = ref(false);
        const { currentHistoryId } = storeToRefs(useHistoryStore());
        const selectedLabelTitle = computed(() => {
            const config = selectorConfig[props.argumentType];
            return (config && config.labelTitle) || "Select Label";
        });
        function getInvocations() {
            return invocationsFetcher({});
        }
        function getJobs() {
            return jobsFetcher({});
        }
        function getWorkflows() {
            return workflowsFetcher({});
        }
        function getHistories() {
            return publishedHistoriesFetcher({});
        }
        function onData(response) {
            dataShow.value = false;
            emit("onInsert", `${props.argumentName}(history_dataset_id=${response})`);
        }
        function onDataCollection(response) {
            dataCollectionShow.value = false;
            emit("onInsert", `${props.argumentName}(history_dataset_collection_id=${response.id})`);
        }
        function onJob(response) {
            jobShow.value = false;
            emit("onInsert", `${props.argumentName}(job_id=${response.id})`);
        }
        function onInvocation(response) {
            invocationShow.value = false;
            emit("onInsert", `${props.argumentName}(invocation_id=${response.id})`);
        }
        function onHistory(response) {
            historyShow.value = false;
            emit("onInsert", `history_link(history_id=${response.id})`);
        }
        function onWorkflow(response) {
            workflowShow.value = false;
            emit("onInsert", `${props.argumentName}(workflow_id=${response.id})`);
        }
        function onVisualization(response) {
            visualizationShow.value = false;
            emit("onInsert", response);
        }
        function onOk(selectedLabel) {
            selectedLabel = selectedLabel || "<ENTER LABEL>";
            selectedShow.value = false;
            if (props.argumentType == "history_dataset_id") {
                if (props.useLabels) {
                    emit("onInsert", `${props.argumentName}(output="${selectedLabel}")`);
                }
                else {
                    dataShow.value = true;
                }
            }
            else if (props.argumentType == "history_dataset_collection_id") {
                if (props.useLabels) {
                    emit("onInsert", `${props.argumentName}(output="${selectedLabel}")`);
                }
                else {
                    dataCollectionShow.value = true;
                }
            }
            else if (props.argumentType == "job_id") {
                if (props.useLabels) {
                    emit("onInsert", `${props.argumentName}(step="${selectedLabel}")`);
                }
                else {
                    jobShow.value = true;
                }
            }
            else if (props.argumentType == "invocation_id") {
                if (props.useLabels) {
                    emit("onInsert", `${props.argumentName}(step="${selectedLabel}")`);
                }
                else {
                    invocationShow.value = true;
                }
            }
        }
        function onCancel() {
            dataCollectionShow.value = false;
            selectedShow.value = false;
            workflowShow.value = false;
            visualizationShow.value = false;
            jobShow.value = false;
            invocationShow.value = false;
            dataShow.value = false;
            emit("onCancel");
        }
        if (props.argumentType == "workflow_id") {
            workflowShow.value = true;
        }
        else if (props.argumentType == "history_id") {
            historyShow.value = true;
        }
        else if (props.argumentType == "history_dataset_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                dataShow.value = true;
            }
        }
        else if (props.argumentType == "history_dataset_collection_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                dataCollectionShow.value = true;
            }
        }
        else if (props.argumentType == "invocation_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                invocationShow.value = true;
            }
        }
        else if (props.argumentType == "job_id") {
            if (props.useLabels) {
                selectedShow.value = true;
            }
            else {
                jobShow.value = true;
            }
        }
        else if (props.argumentType == "visualization_id") {
            visualizationShow.value = true;
        }
        return { __sfc: true, props, emit, selectorConfig, selectedShow, visualizationShow, workflowShow, historyShow, jobShow, invocationShow, dataShow, dataCollectionShow, currentHistoryId, selectedLabelTitle, getInvocations, getJobs, getWorkflows, getHistories, onData, onDataCollection, onJob, onInvocation, onHistory, onWorkflow, onVisualization, onOk, onCancel, MarkdownSelector, MarkdownVisualization, DataDialog, BasicSelectionDialog, DatasetCollectionDialog };
    }
});
